import { useCallback, useRef } from 'react';

import useDraggableItem from '@/modules/corporate/components/DraggableList/hooks/useDraggableItem';
import { DraggableListProps } from '@/modules/corporate/components/DraggableList/types';

interface Params {
  onDrop: DraggableListProps['onDrop'];
}

const useDraggableList = ({ onDrop: onDropProp }: Params) => {
  const draggingItemRef = useRef<number | undefined>();

  const onDrop = useCallback(
    (to: number) => {
      const fromIndex = draggingItemRef.current;
      if (typeof fromIndex !== 'number') {
        return;
      }

      const toIndex = to < fromIndex ? to + 1 : to;
      if (fromIndex === toIndex) {
        return;
      }

      onDropProp({ fromIndex, toIndex });
    },
    [onDropProp],
  );

  const { getDropOverContainerProps } = useDraggableItem({ key: -1, draggingItemRef, onDrop });

  return { draggingItemRef, getDropOverContainerProps, onDrop };
};

export default useDraggableList;
